import React, { useEffect, useState } from 'react';
import Modalimg from './modal';
import Projectsimage from './projectsimage';
import styled from 'styled-components';
import { Link } from 'react-router-dom'; 

import img1 from '../components/assets/Crewai.png';
import img7 from '../components/assets/yourproject.png';
import studentChakraImg from '../components/assets/student_chakra.webp';
import clokamImg from '../components/assets/Clokam.webp';
import sevakImg from '../components/assets/sevak.webp';
import spoorthiImg from '../components/assets/spoorthi.webp';
import shadabImg from '../components/assets/shadab.webp';
import { isVideoMedia, resolveMediaSrc } from '../utils/mediaUtils';


const project = [

    {
        title: 'Shadab Restaurant',
        src: shadabImg,
        src1: shadabImg,
        niech: 'Food Delivery App & Website — Pan India, Quick Commerce, Quick Delivery – Completed',
        url: 'shadab',
        badge: 'Featured',
    },
    {
        title: 'AI Property Recommender',
        src: img1,
        src1: img1,
        niech: 'Real Estate (USA) - Completed',
        url: 'ai',
    },
    {
        title: 'Spoorthi CRM',
        src: spoorthiImg,
        src1: spoorthiImg,
        niech: 'School Management System – Completed',
        url: 'spoorthi-crm',
    },
    // {
    //     title: 'Unifyx',
    //     src: img1,
    //     src1: img5,
    //     niech: 'Food Delivery Website (Ireland) - Completed'
    // },
    {
        title: 'Unifyx',
        src: 'https://genzixbackend.s3.ap-south-1.amazonaws.com/unifyx_new.mp4',
        src1: 'https://genzixbackend.s3.ap-south-1.amazonaws.com/unifyx_new.mp4',
        niech: 'Responsive Portfolio Website – Completed',
        url: 'unifyx',
    },
    {
        title: 'FitSage',
        src:  "https://genzixbackend.s3.ap-south-1.amazonaws.com/fitsage.mp4",
        src1: "https://genzixbackend.s3.ap-south-1.amazonaws.com/fitsage.mp4",
        niech: 'AI Diet & Fitness App – iOS / Android',
        url: 'fitsage',
    },
    {
        title: 'Student Chakra',
        src: studentChakraImg,
        src1: studentChakraImg,
        niech: 'Student Network Platform – Completed',
        url: 'student-chakra',
    },
    {
        title: 'Clokam',
        src: clokamImg,
        src1: clokamImg,
        niech: 'Community-Based App – Completed',
        url: 'clokam',
    },
    {
        title: 'SEVAK',
        src: sevakImg,
        src1: sevakImg,
        niech: 'Citizen Issue Resolution Platform – Completed',
        url: 'sevak',
    },
    {
        title: 'Your Project',
        src: img7,
        url: 'contactus',
    },
];

const CustomStyle = styled.div`
  width: 90vw;
  height: auto;
  margin-left: 5%;
  margin-right: 5%;
  background-color: #EDE9E3;
  border-radius: 40px;
  align-items: center;
  justify-content: start;
  border: 1px solid  #000000 ;
  display: flex;
  flex-direction: column;

`;

const Custombutton = styled.div`
  height: auto;
  background-color: #EDE9E3;
  border-radius: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid  #000000 ;
  display: flex;
  color: inherit;
  text-decoration: none;
   &:hover {
    background-color: #FFCF96;  
  }
`;

const Projectgalle = () => {
    const [modal, setModal] = useState({ active: false, index: 0 });
    const [hiddenClass, setHiddenClass] = useState('');
    const [hiddenClassmobile, setHiddenClassmobile] = useState('');
    const [activeProject, setActiveProject] = useState(null);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1200) {
                setHiddenClass('hidden');
            } else {
                setHiddenClass('');
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const handleResizemobile = () => {
            if (window.innerWidth < 480) {
                setHiddenClassmobile('hidden');
            } else {
                setHiddenClassmobile('');
            }
        };

        window.addEventListener('resize', handleResizemobile);
        handleResizemobile(); // Initial check

        return () => {
            window.removeEventListener('resize', handleResizemobile);
        };
    }, []);


    return (
        <div style={{ backgroundColor: '#EDE9E3', width: "100%", minHeight: '170vh' ,overflow:'hidden' }}>
            {hiddenClass ? (
                <div style={{paddingTop:"5vh", background:'EDE9E3', paddingBottom:'5vh'}}>
                    {project.map((proj, index) => {
                        return (
                            <CustomStyle 
                                key={index} 
                                style={{ 
                                    marginTop: index === 0 ? '0' : '5vh',
                                    transform: activeProject === index ? 'scale(0.98)' : 'scale(1)',
                                    transition: 'transform 0.2s ease'
                                }}
                                onTouchStart={() => setActiveProject(index)}
                                onTouchEnd={() => setActiveProject(null)}
                            >
                                <div style={{ display: 'flex', width: '80vw', alignItems: 'center', justifyContent: 'space-between', marginTop: '3vh' }}>
                                    <Link to={`/${proj.url}`} className='why' style={{ fontSize: hiddenClassmobile ? '7vw' : '5vw', fontWeight: '500', color: 'inherit', textDecoration: 'none' }}>
                                        {proj.title}
                                    </Link>
                                    <Custombutton 
                                        as={Link}
                                        to={`/${proj.url}`}
                                        aria-label={`View ${proj.title}`}
                                        style={{ 
                                            fontSize: hiddenClassmobile ? '4vw' : '3vw', 
                                            padding:'10px 20px',
                                            backgroundColor: activeProject === index ? '#FFCF96' : '#EDE9E3',
                                            transition: 'background-color 0.2s ease'
                                        }} 
                                    >
                                        View
                                    </Custombutton>
                                </div>
                                <div style={{ height: '45vw', width: '80vw', marginTop: '3vh', borderRadius: '3vh', overflow: 'hidden', marginBottom:'3vh' }}>
                                    {proj.src && isVideoMedia(proj.src) ? (
                                        <video 
                                            src={resolveMediaSrc(proj.src)} 
                                            width="100%" 
                                            height="100%" 
                                            autoPlay 
                                            loop 
                                            muted 
                                            style={{objectFit:'cover'}} 
                                        />
                                    ) : proj.src ? (
                                        <img 
                                            src={resolveMediaSrc(proj.src)} 
                                            alt={proj.title} 
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                        />
                                    ) : null}
                                </div>
                                {proj.niech && (
                                    <div style={{ padding: '0 10% 3vh 10%', textAlign: 'center' }}>
                                        <p style={{ 
                                            fontSize: hiddenClassmobile ? '4vw' : '2.5vw', 
                                            color: '#666', 
                                            margin: 0,
                                            fontFamily: 'Inter, sans-serif',
                                            fontWeight: '300'
                                        }}>
                                            {proj.niech}
                                        </p>
                                    </div>
                                )}
                            </CustomStyle>
                        );
                    })}
                </div>
            ) : (
                <div>
                    <div style={{ marginLeft: '5%', marginRight: '5%', marginBottom: '20vh' }}>
                        {project.map((project, index) => {
                            return <Projectsimage key={index} index={index} title={project.title} niech = {project.niech} src1 = {project.src1} setModal={setModal} url={project.url} />;
                        })}
                    </div>
                    <Modalimg modal={modal} project={project} />
                </div >
            )}

        </div >
    );
}

export default Projectgalle;
